'use client';

import { Accordion } from '@/components/ui/Accordion';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { cn } from '@/lib/cn';
import { useOwner } from '../../context/OwnerProvider';

export function OwnerFaqs() {
  const { owner } = useOwner();
  const faqs = owner.faqs;

  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <div>
      <SectionHeader title="FAQs" />

      <div className="flex flex-col gap-1 items-start w-full md:px-1">
        {faqs.map((faq, index) => (
          <div key={faq.question} className="w-full">
            <div className="flex flex-col items-start w-full">
              <Accordion
                header={faq.question}
                headerClassName={cn('px-2')}
                contentClassName={cn('px-2')}
                closeOnOutsideClick={true}
              >
                <p className="text-body-2 text-primary">{faq.answer}</p>
              </Accordion>
            </div>

            {index < faqs.length - 1 && (
              <div className="flex flex-col items-start justify-center py-0.5 w-full">
                <div className="h-0 w-full border-b border-secondary" />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
